import React, { useEffect } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "antd";
import { CiSaveDown1 } from "react-icons/ci";

export default function ExcelDownloaderYukxati({ data }) {
  // Function to handle Excel download
  const downloadExcel = () => {
    // Data starts from row 4 to leave space for complex headers
    const info = [
      ...[...data]?.map((el, i) => {
        return [
          el?.id,
          el?.name,
          el?.tonna,
          el?.date?.split("T")[0],
          el?.written_by,
          el?.status,
          el?.customer_id,
          el?.comment,
        ];
      }),

      // Add more data rows as needed
    ];

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet([
      ["", "", "", "", "", "", "", ""], // Empty row for spacing
      ["", "", "", "", "", "", "", ""], // Empty row for spacing

      [
        "№",
        "Номи",
        "Микдори TN",
        "Санаси",
        "Yozdi",
        "Status",
        "Xaridor ID",
        "Izox",
      ], // Header row 2
      ...info, // Data rows
    ]);

    // Apply font style to the entire sheet
    const range = XLSX.utils.decode_range(ws["!ref"]); // Get the range of the sheet
    for (let R = range.s.r; R <= range.e.r; ++R) {
      // Loop through rows
      for (let C = range.s.c; C <= range.e.c; ++C) {
        // Loop through columns
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);

        if (!ws[cell_ref]) continue; // Skip if cell is undefined

        ws[cell_ref].s = {
          font: {
            name: "Arial Cyr", // Apply Calibri font
            sz: 9, // Font size 12
            color: { rgb: "000000" }, // Dark grey text
          },
          alignment: {
            horizontal: "center", // Center horizontally
            vertical: "center", // Center vertically
          },
        };
      }
    }

    // Create workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate buffer and save
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, "xissob_kitob.xlsx");
  };

  return (
    <Button
      onClick={downloadExcel}
      icon={<CiSaveDown1 />}
      className="rounded-xl    bg-white"
    ></Button>
  );
}
